import on from '../util/Elements/on'

export default function (Site, $) {
	Site.widget('table', {
		_create () {
			this.table()
		},

		table() {
			const table = this.element.find('table');
			const head  = table.find('tr:first-of-type');
			head.wrap('<thead></thead>');
			table.find('thead').insertBefore(table.find('tbody'));

			var $tr = head.find('td');
			$tr.replaceWith(function () {
				return $('<th/>', {
					html: this.innerHTML
				});
			});

			head.find('th').first().attr('colspan', head[0].childElementCount)
			head.find('th').slice(1).remove()

			this.element.on('scroll', (e) => {
				table.find('thead th').css({
					textIndent: this.element[0].scrollLeft
				})
			})
		}
	})
}